import { Alert, Button } from '@efexteam/components';
import { Typography } from '@mui/material';
import AuthFormContainerStyles from './AuthFormContainer.styles';
import { AuthFormContainerProps } from './AuthFormContainer.types';

export const AuthFormContainer = ({
  title,
  description,
  children,
  onSubmit,
  submitButtonText,
  submitButtonDisabled = false,
  isLoading = false,
  loadingText,
  successMessage,
  errorMessage,
  className,
}: AuthFormContainerProps) => (
  <div className={`${AuthFormContainerStyles.container} ${className || ''}`}>
    <Typography variant="h4" className={AuthFormContainerStyles.title}>
      {title}
    </Typography>

    {description && (
      <Typography
        variant="body2"
        className={AuthFormContainerStyles.description}
      >
        {description}
      </Typography>
    )}

    {successMessage && (
      <div className={AuthFormContainerStyles.alertContainer}>
        <Alert severity="success">{successMessage}</Alert>
      </div>
    )}

    {errorMessage && (
      <div className={AuthFormContainerStyles.alertContainer}>
        <Alert severity="error">{errorMessage}</Alert>
      </div>
    )}

    <form onSubmit={onSubmit} className={AuthFormContainerStyles.form}>
      <div className={AuthFormContainerStyles.fieldContainer}>{children}</div>

      <div className={AuthFormContainerStyles.buttonContainer}>
        <Button
          appearance="primary"
          type="submit"
          disabled={submitButtonDisabled || isLoading}
          className={AuthFormContainerStyles.submitButton}
        >
          {isLoading ? loadingText || 'Loading...' : submitButtonText}
        </Button>
      </div>
    </form>
  </div>
);

export default AuthFormContainer;
